import { useEffect } from "react";
import { useI18n } from "@/lib/i18n";

/**
 * Hook to set the document title based on a translation key or raw string.
 * Automatically appends " | VintMap" to the title.
 */
export function useDocumentTitle(titleKeyOrString: string, isTranslationKey: boolean = true, dynamicValues?: Record<string, any>) {
    const { t } = useI18n();

    useEffect(() => {
        const titlePart = isTranslationKey ? t(titleKeyOrString, dynamicValues) : titleKeyOrString;
        const fullTitle = `${titlePart} | VintMap`;

        // Only update if changed prevents flickering
        if (document.title !== fullTitle) {
            document.title = fullTitle;
        }
    }, [t, titleKeyOrString, isTranslationKey, JSON.stringify(dynamicValues)]);
}
